<section class="position-relative">
  <div class="keen-slider shop-banner" #shopSlider [class.fadeInDown_ShopBanner]="!isShopBannerHidden()"
    [class.fadeOutUp_ShopBanner]="isShopBannerHidden()">
    @for (item of slides(); track $index) {
    <div class="keen-slider__slide shop-banner__slide item">
      @if ($index === 0 || revealSecondarySlides()) {
      <picture>
        <source media="(min-width: 768px)" [srcset]="item.desktopImg" type="image/webp">
        <img [src]="item.mobileImgSm"
             [attr.fetchpriority]="$index === 0 ? 'high' : null"
             [attr.loading]="$index === 0 ? 'eager' : 'lazy'"
             width="430" height="161"
             alt=""
             class="shop-banner__slide-img"
             [class.shop-banner__slide-img--bottom]="item.objectPosition === 'bottom'">
      </picture>
      }
      <h1 class="title animated fadeInLeft">
        {{item.title}}
      </h1>
      @if (item.boldSubtitle) {
      <h2 class="title-2 animated fadeInLeft">
        {{item.boldSubtitle}}
      </h2>
      }
      @if (item.subtitle) {
      <h3 class="subtitle animated fadeInLeft">
        {{item.subtitle}}
      </h3>
      }
      <div class="gradient-overlay animated fadeIn"></div>
    </div>
    }
  </div>

  @if (dotHelper().length > 1) {
  <div class="dots" [class.hide-dots]="isShopBannerHidden()">
    @for (dot of dotHelper(); track $index) {
    <button type="button" title="Slide {{$index + 1}}" (click)="slider.moveToIdx($index)"
      [class]="'dot ' + ($index === currentSlide ? 'active' : '')"></button>
    }
  </div>
  }

</section>